<div class="snapshot"
     (click)="getImage()"
     [ngClass]="getStyleClass()">
  <img [src]="imageSrc" />
  <i *ngIf="loading" class="pi pi-spin pi-spinner"></i>
  <i *ngIf="failed" class="pi pi-exclamation-triangle" pTooltip="{{errorMessage}}"></i>
  <span *ngIf="!loading" class="refresh">Click to refresh</span>
</div>
